import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { SaleInfo } from "../../../models/customer.model";
interface Props {
  sale: SaleInfo;
  handleDetail: Function;
}

const CustomerLoanCard = ({ sale, handleDetail }: Props) => {
  return (
    <Grid
      container
      sx={{ justifyContent: "start", alignItems: "center" }}
      spacing={2}
      columns={14}
    >
      <Grid
        item
        xs={14}
        sm={4}
        md={4}
        lg={3}
        xl={2}
        width={"100%"}
        height={"100%"}
      >
        <Box
          sx={{
            width: "120px",
            height: "120px",
            border: "1px solid #EDEFEF",
            borderRadius: "5px",
            boxShadow: "0px 2px 4px rgba(0,0,0,0.16)",
            padding: "10px",
          }}
        >
          {/* edit condition */}
          {sale?.logoBase64 === null || sale?.logoBase64 === "" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <StorefrontIcon sx={{ color: "#1D4A87", fontSize: "50px" }} />
            </Box>
          ) : (
            <img
              alt={sale?.storeTitle}
              src={`data:image/png;base64,${sale?.logoBase64}`}
              style={{ objectFit: "contain", width: "100%", height: "auto" }}
            />
          )}
        </Box>
      </Grid>
      <Grid item xs={14} sm={10} md={10} lg={11} xl={12}>
        <Grid
          container
          flexDirection={"column"}
          gap={"15px"}
          justifyContent={"center"}
          alignItems={"start"}
          width={"100%"}
        >
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "#1D4A87",
                display: "flex",
                alignItems: "center",
                gap: "7px",
              }}
            >
              {sale?.sellerTitle}
              {sale?.saleType === "Online" ? (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      color: "#1D4A87",
                      backgroundColor: "#EDF1F4",
                      borderRadius: "5px",
                      padding: "7px",
                      width: "fit-content",
                    }}
                  >
                    <LanguageOutlinedIcon sx={{ marginLeft: "7px" }} />
                    فروشگاه آنلاین
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      width: "fit-content",
                      color: "#1D4A87",
                      backgroundColor: "#EDF1F4",
                      borderRadius: "5px",
                      padding: "7px",
                    }}
                  >
                    <StorefrontOutlinedIcon sx={{ marginLeft: "7px" }} />
                    فروشگاه حضوری
                  </Typography>
                </Box>
              )}
            </Typography>
            <Typography
              sx={{ fontSize: ".9rem", color: "#1D4A87", cursor: "pointer" }}
              onClick={() => handleDetail(sale?.referenceKey)}
            >
              <RemoveRedEyeOutlinedIcon
                sx={{ fontSize: "22px", marginLeft: "7px" }}
              />
              جزییات فروش
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              جمع فاکتور:{" "}
              <span style={{ fontWeight: "bold" }}>
                {sale?.totalFactorAmount?.toLocaleString("fa")} ریال
              </span>
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              تاریخ فروش:{" "}
              <span style={{ fontWeight: "bold" }}>
                {sale?.saleDatePersian}
              </span>
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              جمع مبلغ تسویه:{" "}
              <span style={{ fontWeight: "bold" }}>
                {sale?.totalSettlementAmount?.toLocaleString("fa")} ریال
              </span>
            </Typography>
            <Typography sx={{ fontSize: "0.9rem", width: "20%" }}>
              تاریخ تسویه:{" "}
              <span style={{ fontWeight: "bold" }}>
                {sale?.settlementDatePersian}
              </span>
            </Typography>
            <Typography sx={{ width: "20%" }}></Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomerLoanCard;
